/*eslint-disable */
define(function (require) {
    var pageConfig = require('common/page-config');
    var moment = require('moment');

    var _self = {
        // Pad out a number with leading zeros
        padOutNumber: function (number, length) {
            var paddedNumber = '0';

            if (length > 1) {
                for (var i = 0; i < length; i++) {
                    paddedNumber += '0';
                }
            }

            paddedNumber += number;

            return paddedNumber;
        },

        // YYYY-MM-DD...
        toJavaSql: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },

        // Pretty print dates, using String based templates like
        // '{day}/{month}/{year}' = DD/MM/YYY. Degrades gracefully.
        // '{dayNames}' and '{monthNames}' are optional.
        printCmsDate: function(date, template, shortMonthNames){
            var formattedDate = '';
            var fragmentedDate = _self.getDayMonthYear(date);
            var dayNameArray = pageConfig.cms.dayNames;

            if (shortMonthNames) {
                    monthNameArray = pageConfig.cms.shortMonthNames;
            } else {
                var monthNameArray = pageConfig.cms.monthNames;
            }

            var dayLabel = dayNameArray[Number(fragmentedDate.day)];
            var monthLabel = monthNameArray[Number(fragmentedDate.month - 1)]

            var formattedDate = template.
                replace('{day}', fragmentedDate.date).
                replace('{month}', fragmentedDate.month).
                replace('{year}', fragmentedDate.year).
                replace('{dayName}', dayLabel).
                replace('{monthName}', monthLabel);

            return formattedDate;
        },

        // Returns an object containing
        // sensible values for the day month and year.
        getDayMonthYear: function(date){
            var day = date.getDay() < 10 ? _self.padOutNumber(Number(date.getDay())) : Number(date.getDay());
            var month = date.getMonth() < 10 ? _self.padOutNumber(Number(date.getMonth() + 1)) : Number(date.getMonth() + 1);
            var year = date.getFullYear();
            var date = date.getDate() < 10 ? _self.padOutNumber(Number(date.getDate())) : Number(date.getDate());

            return {
                day: day,
                month: month,
                year: year,
                date: date }
            ;
        },

        //Returns xx Days / xx Months if date is less than a year ago,
        // if date is over a year - return 'month year'
        getDateSince: function(date) {

        }
    };

    return _self;
});
